import React from "react";

const Benefits = () => {
  return (
    <div className="bfr-benefits-wrapper">
      <h1>
        Benefits of <span>Biometric & Facial </span>Recognition
      </h1>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Enhanced security with foolproof identity verification</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Improved employee attendance tracking</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Reduced fraud and unauthorized access</p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-3">
          <div className="card">
            <p>Seamless user experience with contactless solutions</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
